import { render, staticRenderFns } from "./goodsOrder.vue?vue&type=template&id=87271e52&"
import script from "./goodsOrder.vue?vue&type=script&lang=js&"
export * from "./goodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./goodsOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports